export default __webpack_public_path__ + "static/media/use_mobile_camera.0b249ddb.png";